import { inject, Injectable } from "@angular/core";
import { LabelLang } from "@ennova-research/waveup-common/enum";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { catchError, Observable, of, retry } from "rxjs";
import { I18nService } from "./core/services/i18n/i18n.service";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly i18nService = inject(I18nService);

  getTranslation(language: LabelLang): Observable<Translation> {
    return this.i18nService.getLocaleLabels(language).pipe(
      retry(2),
      catchError((error) => {
        console.error(`Error during ${language} labels loading...`, error);
        return of({});
      })
    );
  }
}
